import { useEffect, useRef, useState } from 'react'

import { PRODUCT_FRUITS_READY_LISTENER } from './useProductFruitsCustomLauncher.constants'

export function useProductFruitsCustomLauncher({ elementRef, enabled }) {
  const [isOpen, setIsOpen] = useState(false)
  const [unreadCount, setUnreadCount] = useState(0)

  const inAppListenersAttachedRef = useRef(false)
  const announcementsListenersAttachedRef = useRef(false)

  useEffect(() => {
    function setup() {
      const inAppCenterApi = window.productFruits?.api?.inAppCenter
      const announcementsApi = window.productFruits?.api?.announcementsV2
      const element = elementRef?.current

      if (
        enabled &&
        announcementsApi &&
        !announcementsListenersAttachedRef.current
      ) {
        announcementsApi.listen('newsfeed-unread-count-changed', data => {
          setUnreadCount(data?.count || 0)
        })

        announcementsListenersAttachedRef.current = true
      }

      if (!enabled || !inAppCenterApi || !element) {
        return
      }

      inAppCenterApi.attachToCustomElement(element)
      setIsOpen(inAppCenterApi.isOpened())

      if (!inAppListenersAttachedRef.current) {
        inAppCenterApi.listen('opened', () => {
          setIsOpen(true)
        })

        inAppCenterApi.listen('closed', () => {
          setIsOpen(false)
        })

        inAppListenersAttachedRef.current = true
      }
    }

    if (!enabled) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- tears down launcher state when disabled
      setIsOpen(false)
      setUnreadCount(0)
      inAppListenersAttachedRef.current = false
      announcementsListenersAttachedRef.current = false
    }

    if (enabled) {
      setup()
      window.addEventListener(PRODUCT_FRUITS_READY_LISTENER, setup)
    }

    return () => {
      window.removeEventListener(PRODUCT_FRUITS_READY_LISTENER, setup)
    }
  }, [elementRef, enabled])

  return {
    isOpen,
    unreadCount,
  }
}
